package io.horion.cv.sections

import androidx.compose.runtime.Composable
import androidx.compose.runtime.getValue
import androidx.compose.web.events.SyntheticMouseEvent
import com.varabyte.kobweb.compose.css.FontWeight
import com.varabyte.kobweb.compose.css.TextAlign
import com.varabyte.kobweb.compose.css.WhiteSpace
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.border
import com.varabyte.kobweb.compose.ui.modifiers.borderRadius
import io.horion.cv.utils.Colors
import com.varabyte.kobweb.silk.components.forms.Button
import com.varabyte.kobweb.compose.ui.modifiers.color
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxHeight
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxSize
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxWidth
import com.varabyte.kobweb.compose.ui.modifiers.fontFamily
import com.varabyte.kobweb.compose.ui.modifiers.fontSize
import com.varabyte.kobweb.compose.ui.modifiers.fontWeight
import com.varabyte.kobweb.compose.ui.modifiers.height
import com.varabyte.kobweb.compose.ui.modifiers.margin
import com.varabyte.kobweb.compose.ui.modifiers.maxWidth
import com.varabyte.kobweb.compose.ui.modifiers.padding
import com.varabyte.kobweb.compose.ui.modifiers.position
import com.varabyte.kobweb.compose.ui.modifiers.textAlign
import com.varabyte.kobweb.compose.ui.modifiers.whiteSpace
import com.varabyte.kobweb.compose.ui.styleModifier
import com.varabyte.kobweb.core.rememberPageContext
import com.varabyte.kobweb.framework.annotations.DelicateApi
import com.varabyte.kobweb.silk.components.text.SpanText
import com.varabyte.kobweb.silk.style.breakpoint.Breakpoint
import com.varabyte.kobweb.silk.style.toModifier
import com.varabyte.kobweb.silk.theme.breakpoint.rememberBreakpoint
import com.varabyte.kobweb.silk.theme.colors.ColorMode
import io.horion.cv.styles.CoverButtonHeroRadiusStyle
import io.horion.cv.styles.CoverButtonStyle
import io.horion.cv.styles.HeroBannerStyle
import io.horion.cv.styles.HeroContentPaddingStyle
import io.horion.cv.styles.HeroOverlayStyle
import io.horion.cv.styles.HeroSubtitleStyle
import io.horion.cv.styles.HeroSubtitleStylecss
import io.horion.cv.styles.HeroTextColumnStyle
import io.horion.cv.styles.HeroTitleStylecss
import io.horion.cv.styles.MotiveButtonLabelLongStyle
import io.horion.cv.styles.MotiveButtonLabelShortStyle
import io.horion.cv.styles.MotiveButtonStyle
import io.horion.cv.utils.Constants.POPPINS
import io.horion.cv.utils.Constants.UBUNTU
import org.jetbrains.compose.web.css.LineStyle
import org.jetbrains.compose.web.css.Position
import org.jetbrains.compose.web.css.px
import org.jetbrains.compose.web.dom.Text

@OptIn(DelicateApi::class)
@Composable
fun CoverLetterHeroSection() {
    val ctx = rememberPageContext()
    val colorMode by ColorMode.currentState
    val isDark = colorMode.isDark

    val overlayColor = if (isDark) "rgba(0, 0, 0, 0.25)" else "rgba(0, 0, 0, 0.0)"

    Box(
        modifier = HeroBannerStyle.toModifier()
            .fillMaxWidth()
            .styleModifier {
                property("background-image", "url('banniere-webb.webp')")
                property("background-repeat", "no-repeat")
            }
            .position(Position.Relative)
    ) {
        // Overlay sombre
        Box(
            modifier = Modifier
                .fillMaxSize()
                .styleModifier {
                    property("background", overlayColor)
                    property("transition", "background 200ms ease")
                    property("position", "absolute")
                    property("top", "0")
                    property("left", "0")
                    property("pointer-events", "none")
                }
        )

        // Contenu
        Box(
            modifier = HeroContentPaddingStyle.toModifier()
                .fillMaxHeight()
                .fillMaxWidth(),
            contentAlignment = Alignment.CenterStart
        ) {
            Column(
                modifier = HeroTextColumnStyle.toModifier(),
                horizontalAlignment = Alignment.Start
            ) {
                SpanText(
                    "LETTRE DE MOTIVATION",
                    modifier = HeroTitleStylecss.toModifier()
                        .color(Colors.DarkBlue)
                        .fontFamily(POPPINS)
                        .fontWeight(FontWeight.Bold)
                )

                SpanText(
                    "Distinguez-vous\ndu reste avec une\nen bonne et due forme",
                    modifier = HeroSubtitleStylecss.toModifier()
                        .color(Colors.DarkBlue)
                        .fontFamily(POPPINS)
                        .fontWeight(FontWeight.Normal)
                        .textAlign(TextAlign.Start)
                        .whiteSpace(WhiteSpace.PreWrap)
                )

                MotiveButton(
                    onClick = { ctx.router.navigateTo("/motivation") }
                )
            }
        }
    }
}

@Composable
fun MotiveButton(
    onClick: (SyntheticMouseEvent) -> Unit,
) {
    Button(
        onClick = onClick,
        modifier = CoverButtonStyle.toModifier()
            .then(MotiveButtonStyle.toModifier())
            .borderRadius(44.px)
            .fontFamily(UBUNTU)
            .fontWeight(FontWeight.Medium)
            .styleModifier {
                property("display", "inline-flex")
                property("align-items", "center")
                property("justify-content", "center")
            }
    ) {
        SpanText("Créer une lettre", modifier = MotiveButtonLabelShortStyle.toModifier())
        SpanText("Créer une lettre de motivation", modifier = MotiveButtonLabelLongStyle.toModifier())
    }
}